import { createApp } from 'vue';
import HelpWidget from '@app/widget/help.vue';
import useI18n from '@utils/I18n';

const startHelpWidget = async () => {
    const elements = document.querySelectorAll<HTMLElement>('[data-help-widget]');
    for (const el of Array.from(elements)) {
        const props = JSON.parse(el.dataset.props);
        const app = createApp(HelpWidget, { ...props });
        app.use(await useI18n());
        app.mount(el);
    }
};

export const init = () => {
    startHelpWidget();
};
